import { formatPrice } from "@estaly/ui";

// Sales targets ("tiers") of a challenge rewarded by the highest target reached, counted in plan sales or gross sales.
// A tier reward is its label when it is not a gift card amount (e.g. a trip), or its amount.

// Leads must cover this share of the gross sales for the rewards of a gross sales challenge to be unlocked
export const COMPLIANCE_THRESHOLD = 90;

export const isTieredChallenge = (challenge) => challenge?.type === "sales";

export const isGrossSalesCounting = (countingMethod) => countingMethod === "gross_sales";

export const isGrossSalesChallenge = (challenge) => isGrossSalesCounting(challenge?.countingMethod);

export const sortTiers = (tiers = []) => [...tiers].sort((a, b) => a.target - b.target);

export const nextTier = (tiers, score) => sortTiers(tiers).find((tier) => tier.target > (score || 0)) ?? null;

export const reachedTier = (tiers, score) =>
  sortTiers(tiers)
    .filter((tier) => tier.target <= (score || 0))
    .pop() ?? null;

export const tierReward = (tier) => (tier?.label ? tier.label : formatPrice(tier?.reward ?? 0));

// Reward of a seller: the label of the tier reached when it has one, otherwise the amount computed by the API
export const sellerReward = (tiers, seller) => {
  const tier = reachedTier(tiers, seller.score);
  return tier?.label ? tier.label : formatPrice(seller.rewardAmount ?? 0);
};

// Share of the gross sales covered by a lead, leads being capped at the sales count
export const complianceRate = (leadsCount, salesCount) => {
  if (!salesCount) return 0;
  return Math.round((Math.min(leadsCount || 0, salesCount) / salesCount) * 100);
};
